export const darkTheme = {
  // Background colors
  primaryBg: 'linear-gradient(135deg, #1a2332 0%, #2d3748 50%, #1a2332 100%)',
  secondaryBg: 'rgba(30, 41, 59, 0.9)',
  tertiaryBg: 'rgba(30, 41, 59, 0.8)',
  modalBg: 'rgba(30, 41, 59, 0.95)',
  
  // Text colors - Improved contrast for better readability
  primaryText: '#ffffff',
  secondaryText: '#e2e8f0', // Changed from #93c5fd to #e2e8f0 for better contrast
  tertiaryText: '#cbd5e1', // Changed from #a0aec0 to #cbd5e1 for better contrast
  mutedText: '#94a3b8', // Changed from #64748b to #94a3b8 for better contrast
  
  // Border colors
  primaryBorder: 'rgba(255, 255, 255, 0.1)',
  secondaryBorder: '#334155',
  accentBorder: 'rgba(59, 130, 246, 0.3)',
  
  // Button colors
  primaryButton: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
  secondaryButton: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
  accentButton: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
  dangerButton: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
  
  // Input colors
  inputBg: 'rgba(15, 23, 42, 0.6)',
  inputBorder: 'rgba(255, 255, 255, 0.1)',
  inputFocusBorder: '#3b82f6',
  
  // Card colors
  cardBg: 'rgba(51, 65, 85, 0.95)',
  cardHoverBg: '#1e293b',
  
  // Shadow colors
  primaryShadow: 'rgba(0, 0, 0, 0.3)',
  accentShadow: 'rgba(59, 130, 246, 0.3)',
  
  // Logo gradient
  logoGradient: 'linear-gradient(135deg, #3b82f6 0%, #22c55e 100%)',
  
  // Voice button colors
  voiceButtonIdle: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
  voiceButtonRecording: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
  
  // Quick options colors - Improved contrast
  quickOptionBg: 'rgba(30, 41, 59, 0.8)',
  quickOptionHover: 'rgba(51, 65, 85, 0.9)',
  quickOptionBorder: '#334155',
  quickOptionText: '#e2e8f0', // Changed from #93c5fd to #e2e8f0 for better contrast
  
  // Business type colors - Improved contrast
  businessTypeBg: 'rgba(51, 65, 85, 0.95)',
  businessTypeHover: '#1e293b',
  businessTypeText: '#e2e8f0', // Changed from #a5b4fc to #e2e8f0 for better contrast
  
  // Modal colors
  modalOverlay: 'rgba(0, 0, 0, 0.8)',
  modalBorder: 'rgba(59, 130, 246, 0.3)',
  
  // Close button colors
  closeButtonBg: 'rgba(239, 68, 68, 0.2)',
  closeButtonBorder: 'rgba(239, 68, 68, 0.3)',
  closeButtonText: '#ef4444',
  closeButtonHover: 'rgba(239, 68, 68, 0.3)',
  
  // Thinking animation colors
  thinkingBg: 'rgba(15, 23, 42, 0.9)',
  thinkingBorder: 'rgba(59, 130, 246, 0.2)',
  nucleusGradient: 'radial-gradient(circle, #3b82f6, #1e40af)',
  electronColor: '#60a5fa',
  
  // Message colors
  userMessageBg: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
  botMessageBg: 'rgba(51, 65, 85, 0.8)',
  messageText: '#ffffff',
  
  // Welcome message colors - Improved contrast
  welcomeText: '#e2e8f0', // Changed from #93c5fd to #e2e8f0 for better contrast
  welcomeSubtext: '#cbd5e1', // Changed from #a0aec0 to #cbd5e1 for better contrast
  
  // Additional properties needed by ChatHistory component
  primary: '#3b82f6',
  primaryHover: '#2563eb',
  warningBg: 'rgba(245, 158, 11, 0.2)',
  warningBorder: 'rgba(245, 158, 11, 0.3)',
  warningText: '#fbbf24',
  error: '#ef4444',
  errorBg: 'rgba(239, 68, 68, 0.2)',
  
  // ChatHistory specific properties
  primaryBg: 'rgba(51, 65, 85, 0.95)',
  primaryBgHover: '#1e293b'
}; 